import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PersonAddressService } from '../_services';
import * as PersonAddressActions from '../_actions/personAddress';

@Injectable({
  providedIn: 'root',
})
export class PersonAddressEffects {
  loadPersonAddresses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonAddressActions.loadPersonAddresses),
      mergeMap(() =>
        this.personAddressService.getPersonAddresses().pipe(
          map((personAddresses) =>
            PersonAddressActions.loadPersonAddressesSuccess({ personAddresses })
          ),
          catchError((error) => of(PersonAddressActions.loadPersonAddressesFailure({ error })))
        )
      )
    )
  );

  addPersonAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonAddressActions.addPersonAddress),
      mergeMap(({ personAddress }) =>
        this.personAddressService.savePersonAddress(personAddress).pipe(
          map((savedPersonAddress) =>
            PersonAddressActions.addPersonAddressSuccess({ personAddress: savedPersonAddress })
          ),
          catchError((error) => of(PersonAddressActions.addPersonAddressFailure({ error })))
        )
      )
    )
  );

  updatePersonAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonAddressActions.updatePersonAddress),
      mergeMap(({ personAddress }) =>
        this.personAddressService.savePersonAddress(personAddress).pipe(
          map((updatedPersonAddress) =>
            PersonAddressActions.updatePersonAddressSuccess({ personAddress: updatedPersonAddress })
          ),
          catchError((error) => of(PersonAddressActions.updatePersonAddressFailure({ error })))
        )
      )
    )
  );

  deletePersonAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonAddressActions.deletePersonAddress),
      mergeMap(({ id }) =>
        this.personAddressService.deletePersonAddress(id).pipe(
          map(() => PersonAddressActions.deletePersonAddressSuccess({ id })),
          catchError((error) => of(PersonAddressActions.deletePersonAddressFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private personAddressService: PersonAddressService
  ) {}
}
